
import React, { useState } from "react";
import LogoTipo from "../../Imagens/LOGOTIPO.png";

function Menu() {
  const [menuAberto, setMenuAberto] = useState(false);

  const fecharMenu = () => setMenuAberto(false);

  return (
    <header className="cabecalho">
      <nav className="navbar-site container">
        <a
          href="#banner"
          className="marca"
          aria-label="iSolution - Início"
          onClick={fecharMenu}
        >
          <img src={LogoTipo} alt="iSolution" />
        </a>

        <button
          type="button"
          className="menu-toggle"
          aria-label={menuAberto ? "Fechar menu" : "Abrir menu"}
          aria-expanded={menuAberto}
          onClick={() => setMenuAberto(!menuAberto)}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`menu-links ${menuAberto ? "menu-aberto" : ""}`}>
          <a href="#banner" onClick={fecharMenu}>Início</a>
          <a href="#solucoes" onClick={fecharMenu}>Soluções</a>
          <a href="#parceiros" onClick={fecharMenu}>Clientes</a>
          <a href="#projetos" onClick={fecharMenu}>Sobre os projetos</a>

          <a
            className="btn-contato-menu"
            href="#contato"
            onClick={fecharMenu}
          >
            Vamos conversar
            <span aria-hidden="true"> ↗</span>
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Menu;
